module.exports = __webpack_public_path__ + "static/media/02․05․-1.22165abd.webp";